import { FoundationProject } from '@models';

export interface LfSponsoredProjectsResult {
  lfSponsoredProjects: FoundationProject[];
}
